import { z } from "zod";

export const ScanDataAltriaRcnItemSchema = z.object({
  AccountNumber: z.string(),
  LocationNumbers: z.string().array().optional(),
});

export type ScanDataAltriaRcnItemType = z.infer<
  typeof ScanDataAltriaRcnItemSchema
>;
